import React, { Fragment, useEffect, useRef } from 'react'
import AssetsReportListView from '../../../../components/account/report/assets_rpt/AssetsReportListView'
import { useReactToPrint } from 'react-to-print';
import PrintAssetsReportView from '../../../../components/account/report/assets_rpt/PrintAssetsReportView';
import { useDispatch } from 'react-redux';
import { pageTitle } from '../../../../store/softSlice';
import { PdfExportBtn } from '../../../../widgets/AppBtn';

const AccountAssetsReportListView = ({ PageTitle, setIconsButton }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageTitle({ "title": PageTitle }))
    document.title = `${PageTitle}`;
    setIconsButton(<PdfExportBtn onClick={handlePrintCard} />)
  }, []);
  const componentListRef = useRef();
  const RenderListComponent = React.forwardRef(() => (
    <PrintAssetsReportView />
  ));

  const handlePrintCard = useReactToPrint({
    content: () => componentListRef.current,
  });
  return (
    <Fragment>
      <AssetsReportListView />
      <div className='hidden'>
        <div ref={componentListRef}>
          <RenderListComponent />
        </div>
      </div>
    </Fragment>
  )
}

export default AccountAssetsReportListView